<template>
      <!-- // frame usado para mostrar o tutorial da tela de tarefas -->
    <v-dialog full-width :value="true" scrollable persistent :width="$vuetify.breakpoint.smAndDown ? '100%' : '60%'" v-resize="cardResize">
      <!-- :style="$vuetify.breakpoint.smAndDown ? 'width: 100%!important; height: 100%!important;' : 'width: 60%!important; height: 90%!important;'" -->
      <v-card justify-center>
        <v-card-title>
          <v-icon color="teal" style="padding: 5px;" large>people</v-icon>
          <span :class="$vuetify.breakpoint.smAndDown ? 'headline' : 'display-1'"><strong>Seja bem vindo!</strong></span>
          <v-tooltip bottom>
            <v-btn slot="activator" icon style="right: 0; top: 0; position: absolute" fab @click="closeCard()">
              <v-icon color="black">close</v-icon>
            </v-btn>
            <span>Fechar</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding-bottom: 0px;">
            <v-window v-model="onboarding">
                  <v-layout align-center mb-3>
                      <strong class="title">{{item.title}}</strong>
                  </v-layout>
                  <!-- <v-layout  v-if="onboarding === index" align-center justify-center fill-height tag="v-card-text" :style="`height:${(windowHeight - 330)}px`" column style="padding-top: 0px; padding-bottom: 0px;">
                      <video v-html="item.id_text" class="frame"></video>
                  </v-layout> -->
                  <v-layout  align-center justify-center fill-height tag="v-card-text" :style="`height:${(windowHeight - 330)}px`" column style="padding-top: 0px; padding-bottom: 0px;">
                      <iframe width="100%" height="100%" src="https://app.api.illis.com.br/images/welcome.mp4"></iframe>
                  </v-layout>
            </v-window>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout>
            <v-flex xs4></v-flex>
            <v-flex xs4 class="text-xs-center">
              <v-btn href="https://www.youtube.com/channel/UChnglEU6grDpO2lHvrmyG0Q/playlists" target="_blank">Clique aqui e acesse os nossos tutoriais!</v-btn>
            </v-flex>
            <v-flex xs4 class="text-xs-right">
              <v-btn round color="primary" dark @click="closeCard()">Sair</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
  export default {
    name: 'PUserWelcome',
    props: [],
    data: () => ({
      onboarding: 0,
      windowHeight: 0,
      reloadPage: true,
      item: {
        title: 'Estamos contentes com sua presença aqui!',
        id_text: 'https://www.youtube.com/watch?v=UNGcDBVOWME'
      }
    }),
    mounted () {
      this.cardResize()
    },
    methods: {
      cardResize () {
        this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      },
      closeCard () {
        this.$emit('close')
      }
    },
    computed: {
    }
  }
</script>
<style scoped>
  .frame {
    position: relative;
    height: 100%;
    width: 100%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PUserWelcome.vue